import React from "react";
import "./About.css";
function About() {
  return (
    <section className="about-section container" id="about">
      <div className="about-me">
        <h2>About Me</h2>
        <p>
          My name is Akshat Borwal, and I am an artist. I specialize in adorning
          Lord Shiva using bhang and mawa. Bhang is considered a sacred
          substance that pleases Lord Shiva, and mawa enhances the beauty and
          uniqueness of his adornment. As a devotee of Shiva, I blend my
          devotion and artistic skills to create a distinctive form of worship.
          This unique combination of art and devotion brings me immense
          satisfaction.
        </p>
      </div>
    </section>
  );
}

export default About;
